import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class ContactDigitalAssetDetail extends BaseEntityModel {
  id?: number;
  contactId?: number;
  hadAmazonAccount?: boolean;
  hadGoogleAccount?: boolean;
  hadMicrosoftAccount?: boolean;

  constructor(model: Partial<ContactDigitalAssetDetail> = {}) {
    super(model);

    this.id = model.id;
    this.contactId = model.contactId;
    this.hadAmazonAccount = model.hadAmazonAccount;
    this.hadGoogleAccount = model.hadGoogleAccount;
    this.hadMicrosoftAccount = model.hadMicrosoftAccount;
  }
}
